"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteNewUserModal = void 0;
var InvitePricingModal_1 = __importDefault(require("../../SettingsAngular/InviteUserService/InvitePricingModal"));
var ContactSupportForUsersModal_1 = require("../ContactSupportForUsersModal/ContactSupportForUsersModal");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var InviteNewUserModal = (function () {
    function InviteNewUserModal(invoke, rootStore, seatsService, modalService, serverTelemetry) {
        this.invoke = invoke;
        this.rootStore = rootStore;
        this.seatsService = seatsService;
        this.modalService = modalService;
        this.serverTelemetry = serverTelemetry;
        this.pendingUserDataStore = rootStore.getAccountDataStore().getPendingUsersDataStore();
    }
    InviteNewUserModal.prototype.invite = function (email, origin, options) {
        return __awaiter(this, void 0, Promise, function () {
            var originMappingTelemetry, supportModal, invitePricingModal, isTrial, ctaClicked;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        originMappingTelemetry = Object.freeze({
                            "team share panel": event_tracker_types_1.EventOrigin.QwilrTeamSharePanel,
                            "team settings": event_tracker_types_1.EventOrigin.QwilrTeamSettings,
                            mention: event_tracker_types_1.EventOrigin.QwilrTeamSharePanel,
                            "invite request": event_tracker_types_1.EventOrigin.QwilrInviteRequest,
                        });
                        if (this.pendingUserDataStore.doesEmailExist(email)) {
                            throw new Error("User with email ".concat(email, " has already been invited"));
                        }
                        if (!(this.seatsService.remainingSeats() <= 0 && !this.seatsService.canModifySeats())) return [3, 2];
                        supportModal = new ContactSupportForUsersModal_1.ContactSupportForUsersModal(this.modalService);
                        return [4, supportModal.showModal(1)];
                    case 1:
                        _a.sent();
                        return [2, false];
                    case 2:
                        invitePricingModal = this.invoke(InvitePricingModal_1.default);
                        isTrial = this.rootStore.getAccountDataStore().getPlanDisplayName() === "Trial";
                        return [4, invitePricingModal(1, isTrial, function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4, this.pendingUserDataStore.inviteNewUser(email, options)];
                                        case 1:
                                            _a.sent();
                                            this.serverTelemetry.sendUserInvitedTelemetry({
                                                eventOrigin: originMappingTelemetry[origin],
                                                eventProperties: {
                                                    planPendingInvites: this.pendingUserDataStore.getPendingUsers().length,
                                                    userInviteeType: options === null || options === void 0 ? void 0 : options.role,
                                                },
                                            });
                                            return [2];
                                    }
                                });
                            }); })];
                    case 3:
                        ctaClicked = _a.sent();
                        return [2, ctaClicked];
                }
            });
        });
    };
    return InviteNewUserModal;
}());
exports.InviteNewUserModal = InviteNewUserModal;
